import { CatalogMode, getWithAuthn } from "../../RequestHelpers";
import { deserializeFishAmplifierCatalog, extractBufferMetadata, HcrAmplifier } from "../rna-cish/RnaCatalog";
// Nanograms
var Ugram = /** @class */ (function () {
    function Ugram(ugram) {
        this.ugram = ugram;
    }
    Ugram.prototype.valueWithUnit = function () {
        return this.ugram + " \u03BCg";
    };
    return Ugram;
}());
export { Ugram };
// TODO test
export var deserializeCatalog = function (jsonCatalog) {
    var legacyProbes = jsonCatalog.legacyProbe.probes.map(function (jp) { return ({
        id: jp.id,
        name: jp.name,
        amplifiers: jp.amplifiers.map(function (a) { return ({
            id: a.id,
            amplifier: new HcrAmplifier(a.amplifier.id)
        }); })
    }); });
    var goldProbes = jsonCatalog.goldProbe.probes.map(function (jp) { return ({
        id: jp.id,
        name: jp.name,
        amplifiers: jp.amplifiers.map(function (a) { return ({
            id: a.id,
            amplifier: new HcrAmplifier(a.amplifier.id)
        }); })
    }); });
    var legacyAmplifier = deserializeFishAmplifierCatalog(jsonCatalog.legacyAmplifier);
    var goldAmplifier = deserializeFishAmplifierCatalog(jsonCatalog.goldAmplifier);
    var buffer = {
        sampleTypes: jsonCatalog.buffer.sampleTypes,
        defaultSampleType: jsonCatalog.buffer.defaultSampleType,
        antibody: extractBufferMetadata(jsonCatalog.buffer.antibody),
        amplification: extractBufferMetadata(jsonCatalog.buffer.amplification),
        goldAmpWash: extractBufferMetadata(jsonCatalog.buffer.goldAmpWash)
    };
    var legacyProbesByAmplifierId = new Map();
    legacyProbes.forEach(function (p) {
        p.amplifiers.forEach(function (pa) {
            legacyProbesByAmplifierId.set(pa.id, p);
        });
    });
    var goldProbesByAmplifierId = new Map();
    goldProbes.forEach(function (p) {
        p.amplifiers.forEach(function (pa) {
            goldProbesByAmplifierId.set(pa.id, p);
        });
    });
    return {
        legacyProbe: {
            probes: legacyProbes,
            scales: jsonCatalog.legacyProbe.scaleUgrams.map(function (s) { return new Ugram(s); }),
            defaultScale: new Ugram(jsonCatalog.legacyProbe.defaultScaleUgram),
            probesByAmplifierId: legacyProbesByAmplifierId
        },
        goldProbe: {
            probes: goldProbes,
            scales: jsonCatalog.goldProbe.scaleUgrams.map(function (s) { return new Ugram(s); }),
            defaultScale: new Ugram(jsonCatalog.goldProbe.defaultScaleUgram),
            probesByAmplifierId: goldProbesByAmplifierId
        },
        legacyAmplifier: legacyAmplifier,
        goldAmplifier: goldAmplifier,
        buffer: buffer
    };
};
export var fetchIhc2Catalog = function (mode) {
    var path;
    switch (mode) {
        case CatalogMode.Consumer:
            path = '/order/catalog/ihc2';
            break;
        case CatalogMode.Internal:
            // TODO eventually a different catalog once we have admin only items
            path = '/order/catalog/ihc2';
            break;
        default:
            throw Error("Unknown mode " + mode);
    }
    return getWithAuthn(path)
        .then(function (resp) {
        // TODO check for 200
        return resp.json();
    })
        .then(function (jsonCatalog) {
        return deserializeCatalog(jsonCatalog);
    });
};
var Ihc2CatalogLoader = /** @class */ (function () {
    function Ihc2CatalogLoader(mode) {
        this.mode = mode;
    }
    Ihc2CatalogLoader.prototype.load = function () {
        return fetchIhc2Catalog(this.mode);
    };
    return Ihc2CatalogLoader;
}());
export { Ihc2CatalogLoader };
export var getIhc2AmplifierCatalog = function (legacy, catalog) {
    return legacy ? catalog.legacyAmplifier : catalog.goldAmplifier;
};
export var getIhc2ProbeCatalog = function (legacy, catalog) {
    return legacy ? catalog.legacyProbe : catalog.goldProbe;
};
//# sourceMappingURL=Ihc2Catalog.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/ihc2/Ihc2Catalog.js
// module id = 80
// module chunks = 0